import React from 'react';
import { useAppDispatch } from 'app/store';
import { updateFolderEffect } from 'app/store/SongList/effects';
import { FolderItem } from 'types/song';
import { SongFolderRenameDialogComponent } from './SongFolderRenameDialogComponent';

interface SongFolderRenameDialogProps {
  songFolder: FolderItem | null;
  open: boolean;
  onClose: () => void;
}

export const SongFolderRenameDialog: React.FC<SongFolderRenameDialogProps> = ({
  songFolder,
  open,
  onClose,
}) => {
  const dispatch = useAppDispatch();

  if (!songFolder) {
    return null;
  }

  const handleSubmit = async ({ title }: { title: string }) => {
    if (title) {
      dispatch(
        updateFolderEffect({
          guid: songFolder.guid,
          title,
        })
      );
      onClose();
    }
  };

  return (
    <SongFolderRenameDialogComponent
      open={open}
      folder={songFolder}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
};
